/**
 * A custom component to mask the credit card expiry date
 *
 */
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

export default function CreditCardValidDateMask(props) {
  const { inputRef, mask, ...rest } = props;

  return (
    <MaskedInput
      {...rest}
      guide={false}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask || [/\d/, /\d/, '/', /\d/, /\d/]}
    />
  );
}

CreditCardValidDateMask.propTypes = {
  inputRef: PropTypes.any,
  mask: PropTypes.any,
};
